import React from 'react';
import { chatPersistenceLine } from '../../utils/writerCopy';

/**
 * One quiet line: brainstorming talk vs prose that becomes the book.
 * Parent passes the current room; the sentence follows when that changes.
 */
export default function ChatModeLine({ mode, className = '' }) {
  return (
    <p
      className={`chat-mode-line${className ? ` ${className}` : ''}`}
      role="status"
    >
      {chatPersistenceLine(mode)}
    </p>
  );
}
